export const SET_AUTO_DOCUMENTS = "SET_AUTO_DOCUMENTS";
export const RESET_INITIAL_AUTO_STATE = "RESET_INITIAL_AUTO_STATE";
export const SET_WITNESS_OBJ = "SET_WITNESS_OBJ";
export const SET_INJURED_OBJ = "SET_INJURED_OBJ";
export const SET_PASSENGER_OBJ = "SET_PASSENGER_OBJ";

export const setWitnessObj = (obj) => {
  return (dispatch) => {
    dispatch({ type: SET_WITNESS_OBJ, obj });
  };
};
export const setInjuredObj = (obj) => {
  return (dispatch) => {
    dispatch({ type: SET_INJURED_OBJ, obj });
  };
};
export const setPassengerObj = (obj) => {
  return (dispatch) => {
    dispatch({ type: SET_PASSENGER_OBJ, obj });
  };
};

export const setAutoDocuments = (documents) => {
  return (dispatch) => {
    dispatch({ type: SET_AUTO_DOCUMENTS, documents });
  };
};

export const resetInitialAutoState = () => {
  return (dispatch) => {
    dispatch({ type: RESET_INITIAL_AUTO_STATE });
  };
};
